// extracted by mini-css-extract-plugin
export default {"container":"UserWalletCompany_container__po+Ez"};